import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import { Spin } from "antd";
import "./DocumentInfo.scss";

const DocumentInfoContent = (props: any) => {
  const documentModal = useSelector((state: RootState) => state.engageTranslationState.qualityControlState.modal);

  return (
    <Spin spinning={documentModal.modalLoading}>
      <div className="d-flex flex-column justify-content-between h-100">
        <h4 className="DIM-title">Document Information</h4>
        <div>
          <p className="DIM-subtitle">Document</p>
          <div className="DIM-field">{documentModal.modalData.name || "-"}</div>
        </div>
        <div>
          <p className="DIM-subtitle">Description</p>
          <div className="DIM-textarea">{documentModal.modalData.description || "-"}</div>
        </div>
        <div>
          <p className="DIM-subtitle">Client Name</p>
          <div className="DIM-field">{documentModal.modalData.clientName || "-"}</div>
        </div>
        <div>
          <p className="DIM-subtitle">Engage ID</p>
          <div className="DIM-field">{documentModal.modalData.engageProductionId || "-"}</div>
        </div>
        <div>
          <p className="DIM-subtitle">Source Language</p>
          <div className="DIM-field">{documentModal.modalData.sourceLanguageName || "-"}</div>
        </div>
        <div>
          <p className="DIM-subtitle">Target Language</p>
          <div className="DIM-field">{documentModal.modalData.targetLanguageName || "-"}</div>
        </div>
        <div>
          <p className="DIM-subtitle">Assigned To</p>
          <div className="DIM-field">{documentModal.modalData.qcAssignedTo || "-"}</div>
        </div>
        <div className="DIM-footer">
          <button
            onClick={props.close}
            className="DIM-close-btn">
            Close
          </button>
        </div>
      </div>
    </Spin>
  );
};

export default DocumentInfoContent;
